var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConvenienceStore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Shop-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shop 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.38 11.9a3.71 3.71 0 0 1 -2.93 -1.51 0.25 0.25 0 0 0 -0.4 0 3.59 3.59 0 0 1 -5.85 0 0.25 0.25 0 0 0 -0.4 0 3.71 3.71 0 0 1 -2.93 1.51 3.74 3.74 0 0 1 -2.93 -1.51 0.24 0.24 0 0 0 -0.19 -0.1 0.26 0.26 0 0 0 -0.2 0.1 3.71 3.71 0 0 1 -2.93 1.51l-0.38 0a0.25 0.25 0 0 0 -0.2 0.06 0.26 0.26 0 0 0 -0.08 0.19v9a1.5 1.5 0 0 0 1.5 1.5h17a1.5 1.5 0 0 0 1.5 -1.5v-9a0.25 0.25 0 0 0 -0.08 -0.18 0.26 0.26 0 0 0 -0.19 -0.07ZM15 15a0.38 0.38 0 0 1 0.4 -0.36h3.19A0.38 0.38 0 0 1 19 15v5.14a0.5 0.5 0 0 1 -0.5 0.5h-3a0.5 0.5 0 0 1 -0.5 -0.5Zm-9.5 0a0.35 0.35 0 0 1 0.37 -0.33h5.25a0.36 0.36 0 0 1 0.37 0.33v3.34a0.36 0.36 0 0 1 -0.37 0.33H5.83a0.35 0.35 0 0 1 -0.37 -0.33Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38 10.4a2.45 2.45 0 0 0 2.23 -1.88 2.29 2.29 0 0 0 0 -1.37L21.8 1.68c-0.07 -0.19 -0.21 -0.33 -0.35 -0.33H2.55c-0.14 0 -0.28 0.14 -0.35 0.33L0.4 7.15a2.37 2.37 0 0 0 0 1.37 2.45 2.45 0 0 0 2.22 1.88A2.67 2.67 0 0 0 5 7.52a0.75 0.75 0 0 1 1.5 0 2.66 2.66 0 0 0 2.37 2.88 2.67 2.67 0 0 0 2.38 -2.88 0.75 0.75 0 0 1 1.5 0 2.67 2.67 0 0 0 2.38 2.88 2.66 2.66 0 0 0 2.37 -2.88 0.75 0.75 0 0 1 1.5 0 2.67 2.67 0 0 0 2.38 2.88Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConvenienceStore);
export default ForwardRef;